export default "__VITE_ASSET__BrlR09M2__"